import { Component, OnInit, Input, Output, OnChanges } from '@angular/core';
import { User } from '../../models/user';
import { Document } from '../../models/document';
import { ModulesService } from '../../services/modules.service';
import { Module, Modules } from '../../models/modules';


const selected: Modules[] = [];

@Component({
  selector: 'step-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.scss']
})
export class ModulesComponent implements OnInit {

  @Input() currentuser: User;
  @Input() currentdocument: Document;
  
  @Input() stepcontent: any;

  selected: Module[] = [];
  
  modules: Modules;
  selectedPrincipalLangue: any;
  selectedDevise: Module;

  constructor(private servicemodules: ModulesService) { }

  
  ngOnInit() {
    this.getListmodules();
  }

  getListmodules(){
    this.servicemodules.getModules().subscribe((modules: Modules) => { 
      this.modules = modules;
    });
  }

  selectedModule(modules: Module){
    return this.modules;
  }

  saveModules(){
    this.servicemodules.saveModules(this.modules, this.currentdocument.id, this.currentuser.id);
  }

  changeSelectedDevise(devise: Module){
    this.modules[0].devise.forEach(element => {
      element.selected = false;
    });
    devise.selected = true;
  }

  changeSelectedPrincipalLangue(langue: any){
    /*this.modules[0].principallangue = langue;
    this.selectedPrincipalLangue = langue;*/
    this.modules[0].langues.forEach(element => {
      element.principal = false;
    });
    langue.principal = true;
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/modules/modules.component.ts